import { Component, inject, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from "@angular/material/menu";
import { InteractionPublic } from '../../../../../globalTypes/interactions.types';
import { Store } from '@ngrx/store';
import { Base } from '../../wrapper/base-wrapper.component';
import { interactionsFeature } from '../../../store/interactions.store';
import { takeUntil } from 'rxjs';
import { sortByKey } from '../../../helper/general';
import { Dictionary } from '@ngrx/entity';
import { accountFeature } from '../../../store/account.store';
import { LocationPrivate, LocationPublic } from '../../../../../globalTypes/account.types';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

@Component({
  selector: 'msh-notification-bell',
  imports: [MatIconModule, MatMenu, MatMenuTrigger],
  template: `
  <div class="relative">
    @if (bubbleCount() && (bubbleCount() || 0) > 0) {
      <span class=" right-4 dot ">{{ bubbleCount() }}</span>
    }
    <mat-icon class=" text-copy cursor-pointer mt-1" [mat-menu-trigger-for]="notificationBell">notifications</mat-icon>
    <mat-menu class="" #notificationBell>
      @for(interaction of interactions; track interaction.id){
        <div (click)="goToInteraction(interaction)" [class]="
          ((locationId === interaction.buyerId && interaction.buyerAlert) 
          || (locationId !== interaction.buyerId && interaction.sellerAlert)  ? ' border-orange-400' : ' border-back/70') 
          + ((locationId === interaction.buyerId && !interaction.buyerViewed) 
          || (locationId !== interaction.buyerId && !interaction.sellerViewed)  ? ' bg-orange-400/70' : ' bg-back/70') 
          + ' min-w-36 text-copy border-l-4 text-xs bg-back/70 p-2 px-4 cursor-pointer'" mat-menu-item> 
          @if(interaction.fulfillment.fulfillmentNumber){<div>Fulfillment #: {{interaction.fulfillment.fulfillmentNumber}} </div>}
          @else if(interaction.fulfillment.order.orderNumber){<div>Order #: {{interaction.fulfillment.order.orderNumber}} </div>}
          <div>{{interaction.subject}}</div>
        </div>
      }
    </mat-menu>
  </div>
  `,
  styles: ``
})
export class NotificationBellComponent extends Base<NotificationBellComponent> {

  locationId: string = ''
  interactions: InteractionPublic[] = [];
  bubbleCount = toSignal(inject(Store).select(interactionsFeature.selectTotalUnseenBubbles), { initialValue: 0 });
  
  constructor(
    private store: Store,
    private router: Router,
  ){
    super();
    this.store.select(interactionsFeature.selectEntities).pipe(takeUntil(this.$destroy)).subscribe((interactions: Dictionary<InteractionPublic>)=>{
      const sortedInteractions = Object.values(interactions).filter(i=>!!i).sort(sortByKey("createdAt", -1)) as unknown as InteractionPublic[]
      const distinctInteractions: InteractionPublic[] = []
      const fulfillmentIds: string[] = [];
      sortedInteractions.forEach(interaction => {
        if(!fulfillmentIds.includes(interaction.fulfillment.id)){
          distinctInteractions.push(interaction);
          fulfillmentIds.push(interaction.fulfillment.id)
        }
      })
      this.interactions = distinctInteractions
    })
    this.store.select(accountFeature.selectLocation).pipe(takeUntil(this.$destroy)).subscribe(location=>{
      this.locationId = location?.id || "";
    })
  }

  goToInteraction(interaction: InteractionPublic) {
    const page = this.locationId === interaction.buyerId ? 'purchase' : 'fulfillment';
    this.router.navigate(['order', page, interaction.fulfillment.order.id])
  }
}
